import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import LoginModal from "./LoginModal";
import SignupModal from "./SignupModal";

const Navbar = () => {
  const [showLogin, setShowLogin] = useState(false);
  const [showSignup, setShowSignup] = useState(false);
  const [userEmail, setUserEmail] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const email = localStorage.getItem("userEmail");
    if (email) {
      setUserEmail(email);
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("userEmail");
    setUserEmail("");
    navigate("/"); // redirect to homepage after logout
  };

  return (
    <div className="flex justify-between items-center p-4 shadow bg-white">
      <Link to="/" className="text-xl font-bold">MyStore</Link>

      <div className="flex gap-4 items-center">
        {userEmail ? (
          <>
            <span className="text-black">Welcome, {userEmail.split("@")[0]}</span>
            <Link to="/profile" className="text-black hover:underline">My Account</Link>
            <button onClick={handleLogout} className="text-red-500 hover:underline">Logout</button>
          </>
        ) : (
          <>
            <button onClick={() => setShowLogin(true)} className="text-black hover:underline">Login</button>
            <button onClick={() => setShowSignup(true)} className="text-black hover:underline">Signup</button>
          </>
        )}
        <Link to="/cart" className="relative text-2xl">🛒</Link>
      </div>

      {showLogin && <LoginModal onClose={() => setShowLogin(false)} />}
      {showSignup && <SignupModal onClose={() => setShowSignup(false)} />}
    </div>
  );
};

export default Navbar;
